import { render, staticRenderFns } from "./LabelsmallraamPage.vue?vue&type=template&id=51bc1516"
import script from "./LabelsmallraamPage.vue?vue&type=script&lang=js"
export * from "./LabelsmallraamPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports